module.exports = __webpack_public_path__ + "img/empty_3.2c8c1c15.png";